var map = {
	"./decidim/avatar-multiuser.png": 8825,
	"./decidim/brands/facebook.svg": 3085,
	"./decidim/brands/google.svg": 72916,
	"./decidim/brands/twitter-x.svg": 97489,
	"./decidim/cc-badge.png": 82031,
	"./decidim/decidim-logo.svg": 99339,
	"./decidim/default-avatar.svg": 54991,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 12373,
	"./decidim/icons.svg": 22286,
	"./decidim/pattern.png": 9725,
	"./decidim/placeholder-card-g.svg": 85426,
	"./decidim/placeholder-card-l.svg": 89881,
	"./decidim/placeholder.jpg": 16136,
	"./decidim/remixicon.symbol.svg": 20746,
	"./decidim/vendor/social-share-button/douban.svg": 45037,
	"./decidim/vendor/social-share-button/email.svg": 14894,
	"./decidim/vendor/social-share-button/facebook.svg": 70886,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 14058,
	"./decidim/vendor/social-share-button/hacker_news.svg": 71742,
	"./decidim/vendor/social-share-button/linkedin.svg": 97732,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 15869,
	"./decidim/vendor/social-share-button/pinterest.svg": 19480,
	"./decidim/vendor/social-share-button/reddit.svg": 42354,
	"./decidim/vendor/social-share-button/telegram.svg": 43347,
	"./decidim/vendor/social-share-button/tumblr.svg": 77488,
	"./decidim/vendor/social-share-button/twitter.svg": 5171,
	"./decidim/vendor/social-share-button/vkontakte.svg": 761,
	"./decidim/vendor/social-share-button/wechat.svg": 51052,
	"./decidim/vendor/social-share-button/whatsapp.svg": 3524,
	"./decidim/vendor/social-share-button/x.svg": 45270,
	"./decidim/vendor/social-share-button/xing.svg": 67842
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92718;